import { StyleSheet } from 'react-native';

export const style_desktop = StyleSheet.create({
  barContainer: {
    width: 306,
    height: 30,
    alignSelf: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 33.6,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    textAlign: 'center',
  },
});

export const style_mobile = StyleSheet.create({
  barContainer: {
    width: 257,
    height: 30,
    alignSelf: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 28,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    textAlign: 'center',
  },
});
